// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
  pointer-events: none;
}

.modal.show {
  display: block;
  opacity: 1;
  pointer-events: auto;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-header {
  background-color: var(--e-global-color-primary);
  color: var(--e-global-color-b7be4da);
}

.modal-content {
  background-color: var(--e-global-color-b7be4da);
  color: var(--e-global-color-text);
}

.modal.show.hvr-fade {
  animation: fadeIn 0.5s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.modal-close {
  color: #ffffff;
  padding: 4px;
  background: transparent;
  border: none;
  box-shadow: none;
  line-height: 1;
}
.modal-close:hover {
  color: #f4f4f4;
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/user-delete-popup/user-delete-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,oCAAA;EACA,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;EACA,oBAAA;EACA,oCAAA;AACF;;AAEA;EACE,+CAAA;EACA,oCAAA;AACF;;AAEA;EACE,+CAAA;EACA,iCAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE;IACE,UAAA;EACF;EACA;IACE,UAAA;EACF;AACF;AAEA;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAAF;AAEE;EACE,cAAA;AAAJ","sourcesContent":[".modal {\n  opacity: 0;\n  transition: opacity 0.4s ease-in-out;\n  pointer-events: none;\n}\n\n.modal.show {\n  display: block;\n  opacity: 1;\n  pointer-events: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.modal-header {\n  background-color: var(--e-global-color-primary);\n  color: var(--e-global-color-b7be4da);\n}\n\n.modal-content {\n  background-color: var(--e-global-color-b7be4da);\n  color: var(--e-global-color-text);\n}\n\n.modal.show.hvr-fade {\n  animation: fadeIn 0.5s;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.modal-close {\n  color: #ffffff;\n  padding: 4px;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  line-height: 1;\n\n  &:hover {\n    color: #f4f4f4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
